module.exports = __webpack_public_path__ + "img/1bg@2x.c94577a0.png";